module.exports = __webpack_public_path__ + "img/web_dev.59cdcc81.jpg";